// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jEwf","fullView":"styles_fullView__3U3HJ"};